/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import condeoApi from "../../../common/condeoApi";
import notificationAction from "../../../store/actions/notificationAction";
import { useHistory } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { Box, ListItemIcon, Tooltip, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ArchiveIcon from "@material-ui/icons/Archive";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import DeleteDialog from "../../../common/Dialogs/DeleteDialog/DeleteDialog";
import styles from "./Tenants.module.scss";
import AddIcon from "@material-ui/icons/Add";
import {
  IconButton,
  Button,
  Table,
  TableHead,
  TablePagination,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
} from "@material-ui/core";
import { store } from "../../../store";
import MenuIcon from "@material-ui/icons/Menu";
import { useTranslation } from "react-i18next";
import tenantImg from "../../../assets/Images/tenants.png";
const useStyles = makeStyles((theme) => ({
  root: {},
  grid: {
    flexGrow: 1,
  },
  container: {
    maxHeight: 500,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textFieldMargin: {
    marginTop: "20px",
  },
  icon: {
    minWidth: "35px",
  },
  spinner: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
    justifyContent: "center",
  },
  actionsColumn: {
    width: "140px",
    paddingLeft: "30px",
  },
}));

export default function Tenants(props) {
  const history = useHistory();
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [tenants, setTenants] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [dialogState, setDialogState] = React.useState(false);
  const [deletingTenant, setDeletingTenant] = React.useState(false);
  const { dispatch, state } = useContext(store);
  const { t } = useTranslation();
  const { user } = state;
  const { token } = state.auth;

  useEffect(() => {
    fetchTenants();
  }, []);

  const fetchTenants = () => {
    let request;
    const { propertyId } = props;
    if (propertyId) {
      request = condeoApi.fetchTenantsByPropertyId(token, propertyId);
    } else {
      request = condeoApi.fetchTenants(token);
    }
    request
      .then((result) => {
        if (result.ok) {
          result.json().then((response) => {
            if (response) {
              if (propertyId) {
                setTenants(
                  response.tenants.filter(
                    (t) =>
                      t.unit?.property?.organizationId ===
                        user?.organization?.id &&
                      t.unit?.property?.id === Number(propertyId)
                  )
                );
              } else if (props.unitId) {
                setTenants(
                  response.tenants.filter(
                    (t) => t.unit?.id === Number(props?.unitId)
                  )
                );
              } else {
                setTenants(
                  response.tenants.filter(
                    (t) =>
                      t.unit?.property?.organizationId ===
                      user?.organization?.id
                  )
                );
              }
            }
          });
        }
      })
      .catch((err) => {
        console.log("Could not communicate with the server!", err.message);
        dispatch(
          notificationAction({
            open: true,
            message: t("Errors.general"),
          })
        );
      });
  };
  const handleClose = () => {
    setAnchorEl(null);
    setDialogState(false);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleTenantCreate = (event) => {
    history.push("/tenants/new");
  };
  const onEditTenant = (tenant) => {
    localStorage.setItem(
      "propertyId",
      JSON.stringify(tenant?.unit?.property?.id)
    );
    history.push(`/tenants/${tenant.id}/details`);
  };
  const handleDeleteMenu = (event, tenant) => {
    setAnchorEl(event.currentTarget);
    setDeletingTenant(tenant);
  };
  const handleDeleteDialog = () => {
    setDialogState(true);
    setAnchorEl(null);
  };

  const handlePermanentDelete = () => {
    condeoApi
      .deleteTenant(token, deletingTenant.id)
      .then((result) => {
        if (result.ok) {
          result.json().then((response) => {
            if (response.success) {
              setDialogState(false);
              fetchTenants();
              dispatch(
                notificationAction({
                  open: true,
                  message: t("Delete.tenant"),
                })
              );
            }
          });
        } else if (result.status === 401) {
          dispatch(
            notificationAction({
              open: true,
              message: t("Errors.401"),
            })
          );
        }
      })
      .catch((err) => {
        console.log("Could not communicate with the server!", err.message);
        dispatch(
          notificationAction({
            open: true,
            message: t("Errors.general"),
          })
        );
      });
  };
  return (
    <React.Fragment>
      <div className={styles.header}>
        <Typography variant="h6">{t("Tenants.1")}</Typography>
        {user?.admin && tenants && tenants?.length > 0 && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleTenantCreate}
            startIcon={<AddIcon />}
          >
            {t("Tenants.newTenant")}
          </Button>
        )}
      </div>
      {tenants && tenants?.length > 0 && (
        <Paper className={classes.root}>
          <DeleteDialog
            open={dialogState}
            onDialogClose={handleClose}
            onDelete={handlePermanentDelete}
          />
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Tenants.fullName")}</TableCell>
                  <TableCell>{t("Tenants.email")}</TableCell>
                  <TableCell>{t("Tenants.phone")}</TableCell>
                  <TableCell>Unit</TableCell>
                  <TableCell>Property</TableCell>
                  <TableCell align="center">{t("Actions.1")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tenants?.map((tenant) => {
                  return (
                    <TableRow key={tenant.id}>
                      <TableCell className={styles.tableCell}>
                        {tenant?.firstName} {tenant?.lastName}
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        {tenant.email}
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        {tenant.phone}
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        {tenant.unit?.label}
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        {tenant.unit?.property?.label}
                      </TableCell>
                      <TableCell align="center" className={styles.TableCell}>
                        <Tooltip title="Details">
                          <IconButton onClick={() => onEditTenant(tenant)}>
                            <MenuIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton
                            onClick={(event) => handleDeleteMenu(event, tenant)}
                          >
                            <DeleteOutlineIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  elevation={1}
                >
                  <MenuItem onClick={handleClose}>
                    <ListItemIcon className={classes.icon}>
                      <ArchiveIcon fontSize="small" />
                    </ListItemIcon>
                    {t("Delete.archive")}
                  </MenuItem>
                  <MenuItem onClick={() => handleDeleteDialog()}>
                    <ListItemIcon className={classes.icon}>
                      <DeleteOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    {t("Delete.permanentDelete")}
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <ListItemIcon className={classes.icon}>
                      <CloseIcon fontSize="small" />
                    </ListItemIcon>
                    {t("Actions.cancel")}
                  </MenuItem>
                </Menu>
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={tenants ? tenants.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Paper>
      )}
      {tenants && tenants.length === 0 && (
        <Box className={styles.emptyStateContainer}>
          <img src={tenantImg} alt="No Tenants" style={{ maxWidth: "15em" }} />
          <Typography
            variant="body2"
            color="textSecondary"
            className={styles.emptyStateText}
          >
            There are currently no Tenants to display.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleTenantCreate}
            endIcon={<AddIcon />}
            className={styles.emptyStateBtn}
          >
            {t("Tenants.newTenant")}
          </Button>
        </Box>
      )}
    </React.Fragment>
  );
}
